import { useApp } from '../../app/context';
import { InstallGuideDialog } from './InstallGuideDialog';
import { InviteDialog } from './InviteDialog';
import { RaceSettingsDialog } from './RaceSettingsDialog';
import { RoomsDialog } from './RoomsDialog';
import { SettingsDialog } from './SettingsDialog';

/** Renders the dialog chosen in UiStore (at most one at a time). */
export function Dialogs() {
  const { ui } = useApp();
  const close = () => ui.closeDialog();
  switch (ui.dialog.value) {
    case 'settings':
      return <SettingsDialog onClose={close} />;
    case 'rooms':
      return <RoomsDialog onClose={close} />;
    case 'invite':
      return <InviteDialog onClose={close} />;
    case 'installGuide':
      return <InstallGuideDialog onClose={close} />;
    case 'race':
      return <RaceSettingsDialog onClose={close} />;
    case null:
      return null;
  }
}
